import React from 'react';
import img from '../../../src/assets/brainer1.gif'
import img1 from '../../../src/assets/brainer2.gif'
import img2 from '../../../src/assets/brainner3.gif'


const Brainer = () => {
    return (
        <>
            <div className="brainer-section">
                <div className="container">
                    <h5 className="section-head mb72 brainer-head">Why It’s a No-Brainer</h5>
                    <div className="row pad-bainer">
                        <div className="col-md-4 mb52">
                            <div className="text-center">
                                <div className="brainer-img-div">
                                    <img src={img} alt="Brainer Step 1" className="brainer-img" loading="lazy" />
                                </div>
                                <h5 className="title-brainer">Test. Treat. Swim.</h5>
                                <p className="brainer-p">Exact doses in seconds</p>
                            </div>
                        </div>
                        <div className="col-md-4 mb52">
                            <div className="text-center">
                                <div className="brainer-img-div">
                                    <img src={img1} alt="Brainer Step 2" className="brainer-img" loading="lazy" />
                                </div>
                                <h5 className="title-brainer">Slash Costs</h5>
                                <p className="brainer-p">Save 30%+ on chems</p>
                            </div>
                        </div>
                        <div className="col-md-4 mb52">
                            <div className="text-center">
                                <div className="brainer-img-div">
                                    <img src={img2} alt="Brainer Step 3" className="brainer-img" loading="lazy" />
                                </div>
                                <h5 className="title-brainer">HelpBot 24/7</h5>
                                <p className="brainer-p">Real fixes, real-time</p>
                            </div>
                        </div>
                        <div className='col-12 d-flex justify-content-center'>
                        <button className="btn btn-video btn-mobile btn-nobrainer landing-slider-button">
                              
                               THIS REALLY IS A NO-BRAINER — LET’S START YOUR TRIAL
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Brainer;
